// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";

import { IAcademyDocumentFolder } from "../../Models/IAcademyDocumentFolder";
import { baseUrl } from "../../helpers/constants";
import AcademyDocumentFolder from "./AcademyDocumentFolder";
import { IAppUserDto } from "../../Models/IAppUserDto";
import authService from "../api-authorization/AuthorizeService";
import {
  getAllAcademyUsers,
  getLuebberingUsers,
} from "../../helpers/peoplePickerHelpers";
import AddOrUpdateAcademyFolderDialog from "./AddOrUpdateAcademyFolderDialog";

import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  AddFilled,
  ArrowCounterclockwiseRegular,
  FilterRegular,
  HatGraduationSparkleRegular,
  IosArrowRtl24Regular,
} from "@fluentui/react-icons";
import {
  Badge,
  Button,
  createTableColumn,
  Dropdown,
  Field,
  Link,
  Menu,
  MenuItemCheckbox,
  MenuList,
  MenuPopover,
  MenuTrigger,
  MessageBar,
  Option,
  ProgressBar,
  Tab,
  TableCellLayout,
  TableColumnDefinition,
  TabList,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import LuebPagedDataGrid from "../../Controls/LuebPagedDataGrid";
import Header from "../Layout/Header";
import useWindowSize from "../../helpers/useWindowSize";
import HeaderTextAnimation from "../Layout/HeaderTextAnimation";

// Props
interface IAcademyAdminHomeProps {}

// Function
function AcademyAdminHome(props: IAcademyAdminHomeProps) {
  const windowSize = useWindowSize();
  const [selectedTab, setSelectedTab] = useState<string>("schraubtechnik");
  const [selectedAcademySchulung, setSelectedAcademySchulung] =
    useState<IAcademyDocumentFolder>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [academyDocumentFolders, setAcademyDocumentFolders] = useState<
    IAcademyDocumentFolder[]
  >([]);

  const [copyOfAcademyFolder, setCopyOfAcademyFolder] = useState<
    IAcademyDocumentFolder | undefined
  >(undefined);

  const [updateAcademyFolder, setUpdateAcademyFolder] = useState<
    IAcademyDocumentFolder | undefined
  >(undefined);

  const [luebUsers, setLuebUsers] = useState<IAppUserDto[]>([]);
  const [allUsers, setAllUsers] = useState<IAppUserDto[]>([]);

  const [addAcademyFolderIsOpen, setAddAcademyFolderIsOpen] =
    useState<boolean>(false);

  const [academyDocumentCategories, setAcademyDocumentCategories] = useState<
    string[]
  >([]);

  const getAcademyDocumentFolders = () => {
    setIsLoading(true);
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/Academy/GetAllAcademyDocumentFolders`)
      .then((data: IAcademyDocumentFolder[]) => {
        const categories = data
          .map((item) => item.category)
          .filter((value, index, self) => self.indexOf(value) === index);
        setAcademyDocumentCategories(categories.filter((x) => x != undefined));

        setAcademyDocumentFolders(data);

        var allYearsSchraub = data
          .filter((x) => x.category == "schraubtechnik")
          .map((x) => {
            if (typeof x.trainingDateFrom == "string") {
              return x.trainingDateFrom.split("-")[0];
            }
          })
          .filter((year) => year !== undefined) // Entfernen von undefined-Werten
          .sort((a, b) => {
            if (a && b) {
              return b.localeCompare(a);
            } else return 0;
          });

        var uniqueYearsSchraub = [];
        var seenYears: { [key: string]: boolean } = {};

        for (var i = 0; i < allYearsSchraub.length; i++) {
          var year = allYearsSchraub[i];
          if (year && !seenYears[year]) {
            uniqueYearsSchraub.push(year);
            seenYears[year] = true;
          }
        }
        setYearsSchraubToFilter(uniqueYearsSchraub);

        var allYearsBohr = data
          .filter((x) => x.category == "bohrtechnik")
          .map((x) => {
            if (typeof x.trainingDateFrom == "string") {
              return x.trainingDateFrom.split("-")[0];
            }
          })
          .filter((year) => year !== undefined) // Entfernen von undefined-Werten
          .sort((a, b) => {
            if (a && b) {
              return b.localeCompare(a);
            } else return 0;
          });

        var uniqueYearsBohr = [];
        var seenYearsBohr: { [key: string]: boolean } = {};

        for (var i = 0; i < allYearsBohr.length; i++) {
          var year = allYearsBohr[i];
          if (year && !seenYearsBohr[year]) {
            uniqueYearsBohr.push(year);
            seenYearsBohr[year] = true;
          }
        }
        setYearsBohrToFilter(uniqueYearsBohr);

        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //Für den Jahresfilter
  const [yearsSchraubToFilter, setYearsSchraubToFilter] = useState<
    (string | undefined)[]
  >([]);
  const [yearsBohrToFilter, setYearsBohrToFilter] = useState<
    (string | undefined)[]
  >([]);
  const [filter, setFilter] = useState<{ name: string; checked: string[] }>({
    name: "",
    checked: [],
  });

  const [filteredAcademyDocumentFolders, setFilteredAcademyDocumentFolders] =
    useState<IAcademyDocumentFolder[]>([]);

  const handleFilterChange = (name: string, val: any) => {
    setFilter((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  useEffect(() => {
    if (yearsSchraubToFilter.length > 0 && selectedTab == "schraubtechnik") {
      var yearsToFilter: string[] = [];
      if (
        yearsSchraubToFilter[0] != undefined &&
        yearsSchraubToFilter[1] != undefined
      ) {
        yearsToFilter = [yearsSchraubToFilter[0], yearsSchraubToFilter[1]];
      } else if (yearsSchraubToFilter[0] != undefined) {
        yearsToFilter = [yearsSchraubToFilter[0]];
      }
      handleFilterChange("checked", yearsToFilter);
    }

    if (yearsBohrToFilter.length > 0 && selectedTab == "bohrtechnik") {
      var yearsToFilter: string[] = [];
      if (
        yearsBohrToFilter[0] != undefined &&
        yearsBohrToFilter[1] != undefined
      ) {
        yearsToFilter = [yearsBohrToFilter[0], yearsBohrToFilter[1]];
      } else if (yearsBohrToFilter[0] != undefined) {
        yearsToFilter = [yearsBohrToFilter[0]];
      }
      handleFilterChange("checked", yearsToFilter);
    }
  }, [yearsBohrToFilter, yearsSchraubToFilter, selectedTab]);

  useEffect(() => {
    if (selectedTab == "schraubtechnik") {
      var filtered = academyDocumentFolders.filter((x) => {
        if (
          x.category == selectedTab &&
          typeof x.trainingDateFrom == "string" &&
          filter.checked.includes(x.trainingDateFrom.split("-")[0])
        ) {
          return x;
        }
      });
      setFilteredAcademyDocumentFolders(filtered);
    } else if (selectedTab == "bohrtechnik") {
      var filtered = academyDocumentFolders.filter((x) => {
        if (
          x.category == selectedTab &&
          typeof x.trainingDateFrom == "string" &&
          filter.checked.includes(x.trainingDateFrom.split("-")[0])
        ) {
          return x;
        }
      });
      setFilteredAcademyDocumentFolders(filtered);
    }
  }, [filter, academyDocumentFolders, selectedTab]);

  //Für CurrentUser
  const [currentUser, setCurrentUser] = useState<IAppUserDto | undefined>(
    undefined,
  );

  const getCurrentUser = () => {
    authService.getUser().then((user) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result: IAppUserDto) => {
            setCurrentUser(result);
          })
          .catch((error) => {});
      }
    });
  };

  useEffect(() => {
    getCurrentUser();
    getAcademyDocumentFolders();
  }, []);

  useEffect(() => {
    getAllAcademyUsers().then((users) => {
      if (users) {
        setAllUsers(users);
      }
    });
  }, []);

  useEffect(() => {
    getLuebberingUsers().then((luebUsers) => {
      setLuebUsers(luebUsers);
    });
  }, []);

  useEffect(() => {
    if (copyOfAcademyFolder) {
      setAddAcademyFolderIsOpen(true);
    }
  }, [copyOfAcademyFolder]);

  useEffect(() => {
    if (updateAcademyFolder) {
      setAddAcademyFolderIsOpen(true);
    }
  }, [updateAcademyFolder]);

  useEffect(() => {
    if (!addAcademyFolderIsOpen) {
      setCopyOfAcademyFolder(undefined);
      setUpdateAcademyFolder(undefined);
    }
  }, [addAcademyFolderIsOpen]);
  const navigate = useNavigate();

  const columns: TableColumnDefinition<IAcademyDocumentFolder>[] = [
    createTableColumn<IAcademyDocumentFolder>({
      columnId: "name",

      renderHeaderCell: () => "Name",
      renderCell: (item) => (
        <TableCellLayout>
          <Link
            onClick={() => {
              setSelectedAcademySchulung(item);
              navigate("/academyadmin?guid=" + item.guid);
            }}
          >
            {item.title}
          </Link>
        </TableCellLayout>
      ),
    }),
    createTableColumn<IAcademyDocumentFolder>({
      columnId: "zeitraum",

      renderHeaderCell: () => "Zeitraum",
      renderCell: (item) => (
        <TableCellLayout>
          {new Date(item.trainingDateFrom).toLocaleDateString() +
            " - " +
            new Date(item.trainingDateTo).toLocaleDateString()}
        </TableCellLayout>
      ),
    }),
    createTableColumn<IAcademyDocumentFolder>({
      columnId: "trainer",

      renderHeaderCell: () => i18n.t<string>("trainer"),
      renderCell: (item) => (
        <TableCellLayout>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {item.trainer
              ? item.trainer.map((trainer, index) => {
                  if (index == 1) {
                    return <div>{trainer.fullName}</div>;
                  } else {
                    return <div>{trainer.fullName}</div>;
                  }
                })
              : ""}
          </div>
        </TableCellLayout>
      ),
    }),
  ];

  useEffect(() => {
    if (academyDocumentFolders) {
      if (window.location) {
        if (window.location.search) {
          var search = window.location.search.split("=");
          var guid = search[1];
          if (guid) {
            var acadamySchulung = academyDocumentFolders.find(
              (item) => item.guid == guid,
            );
            if (acadamySchulung) {
              setSelectedAcademySchulung(acadamySchulung);
            }
          }
        } else {
          setSelectedAcademySchulung(undefined);
        }
      }
    }
  }, [academyDocumentFolders, window.location.search]);

  return (
    <div>
      {luebUsers && luebUsers.length > 0 && (
        <AddOrUpdateAcademyFolderDialog
          currentUser={currentUser}
          isDialogOpen={addAcademyFolderIsOpen}
          onDismiss={() => setAddAcademyFolderIsOpen(false)}
          onSaved={() => {
            getAcademyDocumentFolders();
            setAddAcademyFolderIsOpen(false);
          }}
          luebUsers={luebUsers}
          copyOfAcademyFolder={copyOfAcademyFolder}
          updateAcademyFolder={updateAcademyFolder}
        />
      )}
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1200 ||
              windowSize.width < 1024 ||
              !selectedAcademySchulung) && (
              <Button
                icon={
                  <HatGraduationSparkleRegular fontSize={24} color="#ff6600" />
                }
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/academyadmin");
                  setSelectedAcademySchulung(undefined);
                }}
              >
                ACADEMY ADMIN
              </Button>
            )}
            {windowSize.width < 1201 &&
              windowSize.width > 1024 &&
              selectedAcademySchulung && (
                <Button
                  style={{ paddingLeft: "0px" }}
                  size="small"
                  onClick={() => {
                    navigate("/academyadmin");
                    setSelectedAcademySchulung(undefined);
                  }}
                  appearance="transparent"
                >
                  <HatGraduationSparkleRegular fontSize={24} color="#ff6600" />
                </Button>
              )}
            {selectedAcademySchulung && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button size="large" appearance="subtle">
                  <HeaderTextAnimation
                    text={selectedAcademySchulung.title ?? ""}
                  />
                </Button>
              </div>
            )}
          </StackShim>
        }
      />

      {!selectedAcademySchulung && (
        <div className="lueb-InnerContentBlockPadding2px">
          <Button
            disabled={luebUsers == undefined || luebUsers.length == 0}
            onClick={() => {
              setAddAcademyFolderIsOpen(true);
            }}
            icon={<AddFilled />}
            appearance="transparent"
          >
            {i18n.t<string>("addAcademyFolder")}
          </Button>
          <Button
            disabled={
              isLoading || luebUsers == undefined || luebUsers.length == 0
            }
            onClick={() => {
              getAcademyDocumentFolders();
            }}
            icon={<ArrowCounterclockwiseRegular />}
            appearance="transparent"
          >
            {i18n.t<string>("refresh")}
          </Button>
          <Menu
            checkedValues={{
              checked: filter.checked.map((x) => {
                return x;
              }),
            }}
            onCheckedValueChange={(ev, data) => {
              handleFilterChange(
                "checked",
                data.checkedItems.map((x) => {
                  return x;
                }),
              );
            }}
          >
            <MenuTrigger disableButtonEnhancement>
              <Button
                disabled={
                  (selectedTab == "schraubtechnik" &&
                    yearsSchraubToFilter.length == 0) ||
                  (selectedTab == "bohrtechnik" &&
                    yearsBohrToFilter.length == 0)
                }
                appearance="subtle"
                icon={<FilterRegular />}
              >
                {"Filter"}
                <Badge style={{ marginLeft: "5px" }}>
                  {filter.checked.length}
                </Badge>
              </Button>
            </MenuTrigger>
            <MenuPopover>
              <MenuList>
                {selectedTab == "schraubtechnik"
                  ? yearsSchraubToFilter.map((item, index) => {
                      return (
                        <MenuItemCheckbox value={item ?? ""} name={"checked"}>
                          {item ?? ""}
                        </MenuItemCheckbox>
                      );
                    })
                  : yearsBohrToFilter.map((item, index) => {
                      return (
                        <MenuItemCheckbox value={item ?? ""} name={"checked"}>
                          {item ?? ""}
                        </MenuItemCheckbox>
                      );
                    })}
              </MenuList>
            </MenuPopover>
          </Menu>
        </div>
      )}
      <>
        {!selectedAcademySchulung && (
          <>
            <TabList selectedValue={selectedTab}>
              <Tab
                onClick={() => {
                  setSelectedTab("schraubtechnik");
                }}
                value={"schraubtechnik"}
              >
                {i18n.t<string>("schraubtechnik")}
              </Tab>
              <Tab
                onClick={() => {
                  setSelectedTab("bohrtechnik");
                }}
                value={"bohrtechnik"}
              >
                {i18n.t<string>("bohrtechnik")}
              </Tab>
            </TabList>
            <div className="lueb-ContentBlock">
              {selectedTab && (
                <>
                  <LuebPagedDataGrid
                    items={filteredAcademyDocumentFolders}
                    columns={columns}
                    resizableColumns
                    sortable
                    columnSizingOptions={{
                      name: {
                        minWidth: 300,
                        defaultWidth: 400,
                      },
                      zeitraum: {
                        minWidth: 200,
                        defaultWidth: 200,
                      },
                      trainer: {
                        minWidth: 200,
                        defaultWidth: 300,
                      },
                    }}
                  />
                  {isLoading && (
                    <Field validationState="none">
                      <ProgressBar />
                    </Field>
                  )}
                  {!isLoading &&
                    academyDocumentFolders.filter(
                      (x) => x.category == selectedTab,
                    ).length == 0 && (
                      <MessageBar intent="info" style={{ marginTop: "5px" }}>
                        {i18n.t<string>("noTrainingsFound")}
                      </MessageBar>
                    )}
                </>
              )}
            </div>
          </>
        )}
        {selectedAcademySchulung && (
          <AcademyDocumentFolder
            allUsers={allUsers}
            isAdmin={true}
            onRefreshRequested={() => getAcademyDocumentFolders()}
            academyDocumentFolder={selectedAcademySchulung}
            onCopyRequested={() => {
              setCopyOfAcademyFolder(selectedAcademySchulung);
            }}
            onUpdateRequested={() => {
              setUpdateAcademyFolder(selectedAcademySchulung);
            }}
          />
        )}
      </>
    </div>
  );
}

export default AcademyAdminHome;
